import { RUN_RATE_SCHEDULE_TYPE } from '../expenseForecast.js';
export function expenseViewOf(schedule) {
    if (schedule.type === RUN_RATE_SCHEDULE_TYPE)
        return 'register';
    switch (schedule.source) {
        case 'csv':
            return 'register';
        case 'contract':
            return 'contracts';
        case 'manual':
            return 'purchase-orders';
        default: {
            const _exhaustive = schedule.source;
            throw new Error(`Unhandled expense schedule source: ${JSON.stringify(_exhaustive)}`);
        }
    }
}
export function isExpenseView(value) {
    return (value === 'register' ||
        value === 'contracts' ||
        value === 'loans' ||
        value === 'purchase-orders');
}
//# sourceMappingURL=expenseViews.js.map